export default "__VITE_ASSET__DsrV7z4Q__"